import React, { useState, useEffect } from 'react';
import $i18n from '@/i18n';
import { Empty } from 'antd';
import Template from './template';
import Requests from '@/services/request';
import { Icon } from '@b-design/fusion';
import { ResponsiveGrid, Loading } from '@alifd/next';
import './index.less';

const { Cell } = ResponsiveGrid;

export interface IAppList {
  tplCode?: string;
  tplName?: string;
  tplDesc?: string;
  iconUrl?: string;
  specCode?: string;
  specs?: {
    specCode: string;
    specName: string;
    codeUrl: string;
    imgs: {
      imgDesc: string;
      imgUrl: string;
    }[];
  }[];
}

const MiniAppTemplate: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [appList, setAppList] = useState<IAppList[]>([]);
  const [[showDetails, recordDetail], setShowDetails] = useState<[boolean, IAppList]>([false, {}]);

  useEffect(() => {
    setLoading(true);
    Requests.get('/rest/intercnn/miniapp/tpl/tplList', {})
      .then((res) => {
        setAppList(res || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="miniAppTemplateContainer">
      <Loading visible={loading}>
        {!showDetails ? (
          <>
            {appList?.length > 0 ? (
              <ResponsiveGrid gap={16} device="desktop">
                {appList.map((i) => {
                  return (
                    <Cell className="mygrid" colSpan={4} key={i.tplCode}>
                      <div className="operate-item">
                        <div className="item-content">
                          {i.iconUrl ? <img className="content-icon" src={i.iconUrl} /> : null}
                          <div className="operate-item-name" title={i.tplName}>
                            {i.tplName}
                          </div>
                        </div>
                        <div className="operate-info">
                          <div className="info">
                            <span className="label">
                              {$i18n.get({
                                id: 'aopf.component.miniAppTemplate.Introduction',
                                dm: '简介',
                              })}
                            </span>
                            <span className="name">{i.tplDesc || ''}</span>
                          </div>
                          <div className="footer">
                            {/* <Button
                              type="primary"
                              size="small"
                              onClick={() => setShowDetails([true, i])}
                            >
                              {$i18n.get({
                                id: 'aopf.component.miniAppTemplate.Details',
                                dm: '详情展示',
                              })}
                            </Button> */}
                            <div>
                              <a onClick={() => setShowDetails([true, i])}>
                                {$i18n.get({
                                  id: 'aopf.component.miniAppTemplate.Details',
                                  dm: '详情展示',
                                })}
                              </a>
                              <Icon type="arrow--right" size="small" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Cell>
                  );
                })}
              </ResponsiveGrid>
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <span>
                    {$i18n.get({
                      id: 'aopf.pages.miniAppStore.setting.category.list.no.data',
                      dm: '暂无数据',
                    })}
                  </span>
                }
              />
            )}
          </>
        ) : (
          <Template data={recordDetail || {}} onBack={() => setShowDetails([false, {}])} />
        )}
      </Loading>
    </div>
  );
};

export default MiniAppTemplate;
